import styled from 'styled-components';

import {
  flexbox,
  justifyContent,
  alignItems
} from '../../styles/helpers/flexbox';

export const QuickSelectorWrapper = styled.div((props) => {
  const { colours } = props.theme;

  return `
  ${flexbox()};
  ${justifyContent('center')};
  ${alignItems('center')};

  width: 40px;
  height: 100%;

  &:hover {
    path {
      fill: ${colours.custom?.[800]} !important;
    }
  }
`;
});

export const QuickSelectorToggleButton = styled.button((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${justifyContent('center')};
    ${alignItems('center')};

    background-color: ${colours.grey[200]};
    border: none;
    width: 100%;
    height: 100%;
  `;
});

export const QuickSelectorRow = styled.div((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${alignItems('center')};

    border-bottom: 1px solid ${colours.grey[400]};
    padding-left: 10px;
    color: ${colours.grey[800]};
    height: 32px;
    cursor: pointer;

    &:hover {
      font-weight: 900;
    }
  `;
});

export const QuickSelectorHeader = styled(QuickSelectorRow)`
  font-weight: 700;
  cursor: default;

  &:hover {
    background-color: white !important;
  }
`;

export const QuickSelectorClearSelections = styled(QuickSelectorRow)`
  border: none;
`;

export const ColorBlock = styled.div((props) => {
  let color;

  switch (props.colorType) {
    case 'result50':
      color = '#900012';
      break;

    case 'result85':
      color = '#2452BB';
      break;

    case 'result100':
      color = '#008902';
      break;

    case 'allAssigned':
      color = '#dae7d3';
      break;

    default:
      color = '#fff';
  }

  return `
    background-color: ${color} !important;
    height: 20px;
    width: 20px;
    margin-right: 10px;
  `;
});

export const AllCellsIcon = styled.div`
  ${flexbox()};
  ${justifyContent('center')};

  width: 20px;
  height: 20px;
  margin-right: 15px;
  padding-top: 5px;
`;



// WEBPACK FOOTER //
// ./components/quick-selector/quick-selector.styled.js